import { render, staticRenderFns } from "./Waste.vue?vue&type=template&id=1bacb8b8&scoped=true&"
import script from "./Waste.vue?vue&type=script&lang=js&"
export * from "./Waste.vue?vue&type=script&lang=js&"
import style0 from "./Waste.vue?vue&type=style&index=0&id=1bacb8b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bacb8b8",
  null
  
)

export default component.exports